import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import Buy from 'products/Buy';

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Buy cartProducts={_cartProducts} skus={_skus} />,
    document.querySelector('.buyApp'),
  )
})
